import { TablePaginationConfig } from 'antd';
import { StateCreator } from 'zustand';

export type HistoricSlice = {
  historicChangelogTablePaginationConfig: TablePaginationConfig;
  setHistoricChangelogTablePaginationConfig: (paginationConfig: TablePaginationConfig) => void;
};

export const historicSliceInitialState: HistoricSlice = {
  historicChangelogTablePaginationConfig: {
    current: 1,
    total: 0,
    pageSize: 10,
  },
  setHistoricChangelogTablePaginationConfig: () => null,
};

export const createHistoricSlice: StateCreator<HistoricSlice, [], [], HistoricSlice> = set => ({
  ...historicSliceInitialState,
  setHistoricChangelogTablePaginationConfig: (paginationConfig: TablePaginationConfig) =>
    set({
      historicChangelogTablePaginationConfig: paginationConfig,
    }),
});
